import { Link, Navigate, useParams } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AGENT_CATALOG, MOBILE_ENABLED_AGENT_IDS } from "@/lib/agent-catalog";
import { ArrowLeft, History, Sparkles } from "lucide-react";

export default function MobileAgentDetailPage() {
  const { agentSlug } = useParams<{ agentSlug: string }>();
  const agent = agentSlug ? AGENT_CATALOG[agentSlug] : undefined;

  if (!agentSlug || !agent) {
    return <Navigate to="/dashboard/agents/mobile" replace />;
  }

  const isMobileReady = MOBILE_ENABLED_AGENT_IDS.has(agentSlug);
  const Icon = agent.icon;

  return (
    <div className="p-4 sm:p-6">
      <Link to="/dashboard/agents/mobile" className="mb-4 inline-flex items-center text-sm text-slate-500 hover:text-slate-700">
        <ArrowLeft className="mr-1 h-4 w-4" /> Volver a agentes
      </Link>

      <Card>
        <CardHeader>
          <div className={`mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${agent.gradient}`}>
            <Icon className="h-6 w-6 text-white" />
          </div>
          <CardTitle>{agent.name}</CardTitle>
          <CardDescription>{agent.description}</CardDescription>
          <div>
            <Badge variant={isMobileReady ? "default" : "secondary"}>
              {isMobileReady ? "Experiencia mobile completa" : "Compatibilidad mobile parcial"}
            </Badge>
          </div>
        </CardHeader>
        <CardContent className="space-y-3">
          {agent.path && (
            <Link to={agent.path} className="block">
              <Button className="w-full justify-start gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold h-11 shadow-sm">
                <Sparkles className="h-4 w-4" /> Abrir {agent.name}
              </Button>
            </Link>
          )}
          <Link to={`/dashboard/agents/mobile/${agentSlug}/history`} className="block">
            <Button variant="outline" className="w-full justify-start gap-2">
              <History className="h-4 w-4" /> Ver historial y estado
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
